<div [style.background-color]="backgroundColor" class="idp-offer-action-banner">
  <div
    class="idp-offer-action-container"
    [ngClass]="orientation === 'vertical' ? '--vertical' : '--horizontal'"
    (click)="handleContainerClick()"
  >
    <ng-container *ngIf="inputType === 'button'">
      <div
        *ngIf="message.subtitle"
        [innerHTML]="message.subtitle"
        [style.color]="messageStyles?.fontColor"
        [style.font-family]="messageStyles?.fontType"
        [style.font-size]="messageStyles?.fontSize"
        class="idp-offer-action__text"
        data-cy="idp-offer-action-banner-description"
      ></div>
      <div
        [style.color]="buttonLabelStyles?.fontColor"
        [style.font-family]="buttonLabelStyles?.fontType"
        [style.font-size]="buttonLabelStyles?.fontSize"
        class="idp-offer-action__btn"
      >
        <idp-button
          (notify)="offerActionFromButton($event)"
          [id]="buttonId || 'fab-offer-action-cta'"
          [label]="buttonLabel ?? ''"
          [ariaLabel]="axTitle + buttonLabel + 'opens in a new tab'"
          [size]="actionSize ?? 'full-width'"
          [type]="actionType ?? 'secondary'"
          data-cy="idp-offer-action-banner-action-button"
        ></idp-button>
      </div>
      <idp-link
        *ngIf="secondaryLink && secondaryLink.url"
        [id]="secondaryLinkId || '#'"
        class="idp-offer-action-container--content-description-link"
        [label]="secondaryLink.label"
        [axLabel]="axTitle + secondaryLink.label"
        [actionUrl]="secondaryLink.url"
        [labelSize]="'large'"
      ></idp-link>
    </ng-container>
    <ng-container *ngIf="inputType === 'checkbox'">
      <div
        [style.color]="messageStyles?.fontColor"
        [style.font-family]="messageStyles?.fontType"
        [style.font-size]="messageStyles?.fontSize"
        class="idp-offer-action__checkbox"
      >
        <idp-checkbox-standard
          (clicked)="offerActionFromCheckbox($event)"
          [uncheckedBackground]="'white'"
          [checked]="isChecked"
        ></idp-checkbox-standard>

        <div class="checkbox__apply-label">
          <span class="apply-label--title" [innerHTML]="message.title"></span>
          <span class="apply-label--subtitle">{{ message.subtitle }}</span>
        </div>
      </div>
    </ng-container>
  </div>
</div>
